import axios from "axios";
import config from "../../../config";
import {
  RoleConfig,
  RoleForm,
  RoleManagementForm,
  RoleType,
} from "../interfaces/RoleConfig";
import { downloadCSV } from "../../../utils/csv";

const { ruleServerUrl, apiServerUrl  } = config;
const formatRole = (roles: RoleConfig[]) => {
  return roles.reduce((acc, role) => {
    const data = Object.entries(role.permissions).reduce(
      (acc, [module, permission]) => {
        const enabled = permission.enabled
          .filter((item) => item !== null)
          .reduce((a, r) => {
            return { ...a, [r]: true };
          }, {});
        const disabled = permission.disabled
          .filter((item) => item !== null)
          .reduce((a, r) => {
            return { ...a, [r]: false };
          }, {});
        return { ...acc, [module]: { ...enabled, ...disabled } };
      },
      {}
    );
    return {
      ...acc,
      [role.name]: { id: role.id, roleName: role.name, permissions: data, generalConfig: role.generalConfig || {} },
    };
  }, {});
};

export const getRoles = () => {
  return axios
    .get(`${ruleServerUrl}/users/roles/currentroleconfig`)
    .then(({ data }) => formatRole(data));
};
// will remove the getRoles, once the migration of permission is done from rule-server
export const getRolesFromApiServer = async () => {
  return axios
    .get(`${apiServerUrl}/users/roles`)
    .then(({ data }) => formatRole(data));
};

export const saveRole = (data: RoleForm) => {
  return axios
    .post(`${ruleServerUrl}/users/roles/save-role-config`, [data])
    .then(({ data }) => data);
};

export const updateRoleGroupGeneralConfig = (roleName: string, generalConfig: object) => {
  return axios
  .post(`${apiServerUrl}/users/roles/save-general-config`, {
    roleName,
    generalConfig
  }).then(({ data }) => {
    return data;
  });
}


export const getDefaultLandingPageForBusiness = async (businessUnitId: number) => {
  return await axios
    .get(`${apiServerUrl}/users/business-configs/${businessUnitId}/default_landing_page`)
    .then((res) => res.data)
    .catch((error) => {
        if (error.response?.status === 404) return null;
        throw error;
      });
};

export const upsertDefaultLandingPageForBusiness = async (
  businessUnitId: number,
  defaultLandingPage: any
) => {
  const updateRequest = {
    configType: 'default_landing_page',
    config: defaultLandingPage,
  };
  return await axios
    .post(
      `${apiServerUrl}/users/business-configs/${businessUnitId}/default_landing_page`,
      updateRequest
    )
    .then((res) => res.data.count)
    .catch((err) => err.message);
};

export const upsertDefaultReportType = async(businessUnitId:number,defaultReportType: any) => {
  const updateRequest = {
    configType: 'default_customer_data_visibility',
    config: defaultReportType,
  };
  return await axios
    .post(
      `${apiServerUrl}/users/business-configs/${businessUnitId}/default_customer_data_visibility`,
      updateRequest
    )
    .then((res) => res.data.count)
    .catch((err) => err.message);
}

export const getDefaultReportType = async(businessUnitId:number) => {
  return await axios.get(
    `${apiServerUrl}/users/business-configs/${businessUnitId}/default_customer_data_visibility`
  ).then((res) => res.data)
    .catch((error) => {
        if (error.response?.status === 404) return null;
        throw error;
      });
}

const formatPermission = (role: RoleType) => {
  let permissions: string[] = [];
  if (role.permissions) {
    Object.values(role.permissions)?.forEach((item) => {
      const enabled = Object.keys(item)?.filter(
        (feature) => item[feature] === true
      );
      permissions = enabled.length ? [...permissions, ...enabled] : permissions;
    });
  }
  return permissions;
};

export const updatePermission = (value: RoleManagementForm) => {
  const formatedResult = Object.values(value).map((role) => {
    const permissions = formatPermission(role);
    return { ...role, permissions: permissions };
  });
  return axios
    .post(`${ruleServerUrl}/users/roles/save-role-config`, formatedResult)
    .then((resp) => resp);
};

export const csvFileDownload = (
  roles: RoleManagementForm,
  featuresList: string[],
  selectedModule: string
) => {
  const roleList = Object.keys(roles);
  const csvHeader = ["Feature / Role", ...roleList];
  const csvBody = featuresList.map((feature) => {
    const featureList = roleList.map((role) => {
      let status = "Inactive";
      Object.entries(roles).forEach(([key, { permissions }]) => {
        if (key === role && permissions[selectedModule][feature]) {
          status = "Active";
        }
      });
      return status;
    });
    return [feature, ...featureList];
  });
  downloadCSV(csvHeader, csvBody, `${selectedModule}-Role Assign.csv`);
};
